import DomainManager from '../../shared/utils/DomainManager';

export const getAuthLink = (pathName: string, targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);

  return `${domainManager.getAuthServiceDomain()}${pathName}`;
};
